/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListJobInstancesRequest = {
  id: string;
  state?: components.ComputeInstanceState | undefined;
  cursor?: string | undefined;
  limit?: number | undefined;
  /**
   * asc pages oldest-first (default); desc pages newest-first. A cursor is only valid within a traversal that keeps the same order.
   */
  order?: components.ComputeOrder | undefined;
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
};

export type ListJobInstancesResponse =
  | components.ComputeInstanceList
  | components.ComputeErrorEnvelope;

/** @internal */
export const ListJobInstancesRequest$inboundSchema: z.ZodType<
  ListJobInstancesRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  id: z.string(),
  state: components.ComputeInstanceState$inboundSchema.optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  order: components.ComputeOrder$inboundSchema.default("asc"),
  "X-On-Behalf-Of": z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
  });
});
/** @internal */
export type ListJobInstancesRequest$Outbound = {
  id: string;
  state?: string | undefined;
  cursor?: string | undefined;
  limit: number;
  order: string;
  "X-On-Behalf-Of"?: string | undefined;
};

/** @internal */
export const ListJobInstancesRequest$outboundSchema: z.ZodType<
  ListJobInstancesRequest$Outbound,
  z.ZodTypeDef,
  ListJobInstancesRequest
> = z.object({
  id: z.string(),
  state: components.ComputeInstanceState$outboundSchema.optional(),
  cursor: z.string().optional(),
  limit: z.number().int().default(50),
  order: components.ComputeOrder$outboundSchema.default("asc"),
  xOnBehalfOf: z.string().optional(),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
  });
});

export function listJobInstancesRequestToJSON(
  listJobInstancesRequest: ListJobInstancesRequest,
): string {
  return JSON.stringify(
    ListJobInstancesRequest$outboundSchema.parse(listJobInstancesRequest),
  );
}
export function listJobInstancesRequestFromJSON(
  jsonString: string,
): SafeParseResult<ListJobInstancesRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListJobInstancesRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListJobInstancesRequest' from JSON`,
  );
}

/** @internal */
export const ListJobInstancesResponse$inboundSchema: z.ZodType<
  ListJobInstancesResponse,
  z.ZodTypeDef,
  unknown
> = z.union([
  components.ComputeInstanceList$inboundSchema,
  components.ComputeErrorEnvelope$inboundSchema,
]);
/** @internal */
export type ListJobInstancesResponse$Outbound =
  | components.ComputeInstanceList$Outbound
  | components.ComputeErrorEnvelope$Outbound;

/** @internal */
export const ListJobInstancesResponse$outboundSchema: z.ZodType<
  ListJobInstancesResponse$Outbound,
  z.ZodTypeDef,
  ListJobInstancesResponse
> = z.union([
  components.ComputeInstanceList$outboundSchema,
  components.ComputeErrorEnvelope$outboundSchema,
]);

export function listJobInstancesResponseToJSON(
  listJobInstancesResponse: ListJobInstancesResponse,
): string {
  return JSON.stringify(
    ListJobInstancesResponse$outboundSchema.parse(listJobInstancesResponse),
  );
}
export function listJobInstancesResponseFromJSON(
  jsonString: string,
): SafeParseResult<ListJobInstancesResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListJobInstancesResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListJobInstancesResponse' from JSON`,
  );
}
